import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IdiomaService } from './idioma.service';
import { Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { Ticket } from '../models/ticket';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  private readonly TIENDA_LS = "tienda";

  private tienda: { id: number; nombre: string };
  private tiendaSubject = new BehaviorSubject<{ id: number; nombre: string }>(null);

  constructor(
    private translateService: TranslateService,
    private idiomaService: IdiomaService
  ) {
    this.idiomaService.getSelectedLanguage$().subscribe(language => {
      this.translateService.use(language); // Cambiar el idioma dinámicamente
    });

    const storedTienda = localStorage.getItem(this.TIENDA_LS);
    if (storedTienda) {
      this.tienda = JSON.parse(storedTienda);
      this.tiendaSubject.next(this.tienda);
    }
  }

  get tienda$(): Observable<{ id: number; nombre: string }> {
    return this.tiendaSubject.asObservable();
  }

  setCurrentTiendaId(tiendaId: number) {
    this.tienda = { id: tiendaId, nombre: null };
    localStorage.setItem(this.TIENDA_LS, JSON.stringify(this.tienda));
    this.tiendaSubject.next(this.tienda);
  }

  setCurrentTienda(tienda: { id: number; nombre: string }) {
    this.tienda = tienda;
    localStorage.setItem(this.TIENDA_LS, JSON.stringify(tienda));
    this.tiendaSubject.next(tienda);
  }

  getCurrentTiendaId(): number {
    if (!this.tienda) {
      const storedTienda = localStorage.getItem(this.TIENDA_LS);
      this.tienda = storedTienda ? JSON.parse(storedTienda) : null;
    }
    return this.tienda?.id;
  }

  getCurrentTiendaNombre(): string {
    if (!this.tienda) {
      const storedTienda = localStorage.getItem(this.TIENDA_LS);
      this.tienda = storedTienda ? JSON.parse(storedTienda) : null;
    }
    return this.tienda?.nombre;
  }

  getCurrentTienda(): { id: number; nombre: string } {
    if (!this.tienda) {
      const storedTienda = localStorage.getItem(this.TIENDA_LS);
      this.tienda = storedTienda ? JSON.parse(storedTienda) : null;
    }
    return this.tienda;
  }

  clearCurrentTiendaId() {
    this.tienda = null;
    localStorage.removeItem(this.TIENDA_LS);
    this.tiendaSubject.next(null);
  }

  public crearOpcionesEstadoActivoListados() {
    let estadoActivacionOpciones = [];
    estadoActivacionOpciones.push(
      { label: this.translateService.instant('campos.estadobjeto.activo'), value: true },
      { label: this.translateService.instant('campos.estadobjeto.inactivo'), value: false },
      { label: this.translateService.instant('campos.estadobjeto.todos'), value: '' }
    )
    return estadoActivacionOpciones;
  }

  public getCamposComunesFormPago(ticket?: Ticket): { [key: string]: any } {
    return {
      conEfectivo: [ticket?.conEfectivo ?? true],
      importeEfectivo: [ticket?.importeEfectivo ?? 0, Validators.min(1)],
      conTarjeta: [ticket?.conTarjeta ?? false],
      importeTarjeta: [{ value: ticket?.importeTarjeta ?? 0, disabled: true }],
      conOtros: [ticket?.conOtros ?? false],
      importeOtros: [{ value: ticket?.importeOtros ?? 0, disabled: true }],
      efectivoEntregado: [ticket?.efectivoEntregado ?? 0],
      cambioDevuelto: [0]
    };
  }

  public formatearFechaISOStr(fecha: Date | string): string {
    if (!fecha) return '';

    if (typeof fecha === 'string') {
      fecha = new Date(fecha);
    }

    // Validar que la fecha sea válida antes de formatear (fix para Safari)
    if (isNaN(fecha.getTime())) {
      console.error('Fecha inválida:', fecha);
      return '';
    }

    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    const day = String(fecha.getDate()).padStart(2, '0');
    const hours = String(fecha.getHours()).padStart(2, '0');
    const minutes = String(fecha.getMinutes()).padStart(2, '0');
    const seconds = String(fecha.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`; // "2025-09-08T22:00:00"
  }

  public formatearFechaISOCalendario(fecha: Date): string {
    if (!fecha) return '';
    return fecha.toISOString().substring(0, 10); // "2025-09-08"
  }

}
